import * as actions from './slice'

const getCampaign = {
  eventName: 'campaignGet',
  onSuccess: [{ action: actions.getCampaign, redux: true }
  ]
}

export { getCampaign }
